import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import { onChange } from '../Storage/utils'
import { useSelectPortalRef } from '../../../../../../SelectPortalProvider'
import { WritableStorageSelect } from '../../../../../selects'

export const BotMutationWhisperWidget: React.FC<WidgetProps> = ({
  value,
  onChange: uiSchemaOnChange
}) => {
  const portalRef = useSelectPortalRef()

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <WritableStorageSelect
        openMenuOnFocus={false}
        menuPortalTarget={portalRef}
        selectedStorageName={value}
        className="e2e-select-step-storage"
        onChange={option => onChange(option ?? null, uiSchemaOnChange)}
      />
    </span>
  )
}
